import o from"styled-components";const e=o.div`
	.date-picker__control {
		height: 40px;
		background-color: ${({theme:o})=>o.bg.primary};
		border-radius: 8px;
		box-sizing: border-box;
		border: none;
		width: 100%;

		&:hover {
			background-color: ${({theme:o})=>o.hover.black15};
			transition: background-color 0.1s ease;
		}
	}

	.date-picker__single-value {
		color: ${({theme:o})=>o.text.input};
		font-size: 13.3333px;
	}

	svg {
		color: ${({theme:o})=>o.text.input};
	}
`;export{e as DateContainer};
